const CHAT_HOSTS = new Set([
  'chat.ivelion.com',
  'chat-dev.ivelion.com',
  'chat.nightingale-ai.com',
  'chat-dev.nightingale-ai.com',
  'chat-dev-1.nightingale-ai.com',
]);

/** Recognize retired specialty handoffs without blocking medical reference links. */
export function isSpecialtyChatLink(
  href: string | undefined,
  currentUrl = typeof window === 'undefined'
    ? 'https://chat.ivelion.com/'
    : window.location.href,
): boolean {
  if (!href) return false;
  try {
    const current = new URL(currentUrl);
    const destination = new URL(href, current);
    if (!['http:', 'https:'].includes(destination.protocol)) return false;
    if (destination.origin !== current.origin && !CHAT_HOSTS.has(destination.hostname)) {
      return false;
    }
    return /^\/(derma|neuro)\/?$/i.test(decodeURIComponent(destination.pathname));
  } catch {
    return false;
  }
}
